import { render, staticRenderFns } from "./tab-app.vue?vue&type=template&id=14c317a1&scoped=true&"
import script from "./tab-app.vue?vue&type=script&lang=js&"
export * from "./tab-app.vue?vue&type=script&lang=js&"
import style0 from "./tab-app.vue?vue&type=style&index=0&id=14c317a1&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c317a1",
  null
  
)

export default component.exports